"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_calendar_1 = __importDefault(require("react-calendar"));
require("react-calendar/dist/Calendar.css");
var general_1 = require("../../lib/general");
require("./style.sass");
var DatePicker = function (_a) {
    var title = _a.title, onChange = _a.onChange, value = _a.value, onClick = _a.onClick, show = _a.show, error = _a.error, onClickDay = _a.onClickDay;
    return (react_1.default.createElement("div", null,
        error && react_1.default.createElement("p", { className: "error" }, error),
        react_1.default.createElement("div", { className: "date-container" },
            react_1.default.createElement("label", { className: "label" }, title),
            react_1.default.createElement("div", { className: "button-wrapper" },
                react_1.default.createElement("button", { onClick: onClick, className: "input-no-shadow", style: {
                        height: "40px",
                        background: "#FFF",
                        alignItems: "center",
                    } },
                    react_1.default.createElement("label", null, value ? (0, general_1.getDateFormat)(value) : "Choose ".concat(title))),
                show && (react_1.default.createElement(react_calendar_1.default, { onChange: onChange, value: value, className: "calender-view", onClickDay: onClickDay, maxDate: new Date() }))))));
};
exports.default = DatePicker;
